import React, { useState, use, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  TextField,
  Stack,
  Box,
  Typography,
} from "@mui/material";
import { useContext } from "react";
import { ApiContext } from "../Context/Context";
import { Link } from "react-router-dom";

import LoginDialog from "./LoginDialog";

import {
  BaseUrl,
  setLogindata,
  setUserdata,
  LoggedInUserID,
  LoggedInUserName,
} from "../Services/Urls";
import { useNavigate } from "react-router-dom";
import FilterParams from "../Classes/FilterParams";

function Footer() {
  const navigate = useNavigate();
  return (
    <>
      <>
        {/* Footer Section Start */}
        <footer className="footer-wrap style2 pt-100">
          <img
            src="assets/img/footer-map.png"
            alt="Image"
            className="footer-shape-one"
          />
          <div className="footer-top">
            <div className="container">
              <div className="row pb-75">
                <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6 pe-xl-5">
                  <div className="footer-widget">
                    <a href="index.html" className="footer-logo">
                      <img src="assets/img/logo.svg" alt="Image" />
                    </a>
                    <p className="comp-desc">
                      Your trusted partner in finding the perfect property.
                      Connecting buyers, sellers, and renters across India.
                    </p>
                  </div>
                </div>
                <div className="col-xl-2 col-lg-6 col-md-6 col-sm-6">
                  <div className="footer-widget">
                    <h3 className="footer-widget-title">Properties</h3>
                    <ul className="footer-menu list-style">
                      <li
                        onClick={(e) => {
                          e.preventDefault();
                          const filters = new FilterParams({
                            propertyType: 1,
                            vertical: 1,
                            featured: null,
                          });

                          navigate("/view-all-listing?tabID=384", {
                            state: {
                              filters: filters,
                            },
                          });
                        }}
                      >
                        <a>
                          <i className="ri-arrow-right-s-line" />
                          Buy Properties
                        </a>
                      </li>
                      <li
                        onClick={(e) => {
                          e.preventDefault();
                          const filters = new FilterParams({
                            propertyType: 1,
                            vertical: 2,
                            featured: null,
                          });

                          navigate("/view-all-listing?tabID=385", {
                            state: {
                              filters: filters,
                            },
                          });
                        }}
                      >
                        <a>
                          <i className="ri-arrow-right-s-line" />
                          Rent Properties
                        </a>
                      </li>
                      <li
                        onClick={(e) => {
                          e.preventDefault();
                          const filters = new FilterParams({
                            propertyType: 2,
                            vertical: 1,
                            featured: null,
                          });

                          navigate("/view-all-listing?tabID=387", {
                            state: {
                              filters: filters,
                            },
                          });
                        }}
                      >
                        <a>
                          <i className="ri-arrow-right-s-line" />
                          Commercial
                        </a>
                      </li>
                      <li
                        onClick={(e) => {
                          e.preventDefault();
                          const filters = new FilterParams({
                            propertyType: 1,
                            vertical: 3,
                            featured: null,
                          });

                          navigate("/view-all-listing?tabID=386", {
                            state: {
                              filters: filters,
                            },
                          });
                        }}
                      >
                        <a>
                          <i className="ri-arrow-right-s-line" />
                          PG & Co-living
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 ps-xl-5">
                  <div className="footer-widget">
                    <h3 className="footer-widget-title">Services</h3>
                    <ul className="footer-menu list-style">
                      <li>
                        <a href="about.html" target="_blank">
                          <i className="ri-arrow-right-s-line" />
                          Home Loans
                        </a>
                      </li>
                      <li>
                        <a href="agents.html" target="_blank">
                          <i className="ri-arrow-right-s-line" />
                          Agent Finder
                        </a>
                      </li>
                      <li>
                        <a href="blog.html" target="_blank">
                          <i className="ri-arrow-right-s-line" />
                          Interior Design
                        </a>
                      </li>
                      <li>
                        <a href="contact.html" target="_blank">
                          <i className="ri-arrow-right-s-line" />
                          Packers & Movers
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                  <div className="footer-widget">
                    <h3 className="footer-widget-title">Company</h3>
                    <ul className="footer-menu list-style">
                      <li>
                        <a href="about.html" target="_blank">
                          <i className="ri-arrow-right-s-line" />
                          About Us
                        </a>
                      </li>
                      <li>
                        <a href="agents.html" target="_blank">
                          <i className="ri-arrow-right-s-line" />
                          Contact
                        </a>
                      </li>
                      <li>
                        <a href="blog.html" target="_blank">
                          <i className="ri-arrow-right-s-line" />
                          Privacy Policy
                        </a>
                      </li>
                      <li>
                        <a href="contact.html" target="_blank">
                          <i className="ri-arrow-right-s-line" />
                          Terms of Service
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="footer-bottom">
              <div className="row align-items-center">
                <div className="col-md-12">
                  <p className="copyright-text">
                    <i className="ri-copyright-line" />
                    All Rights Reserved By{" "}
                    <a href="https://hibootstrap.com/" target="_blank">
                      Landpanda
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </footer>
        {/* Footer Section End */}
      </>
    </>
  );
}

export default Footer;
